import { CALL_API } from '../middleware/api'

// ─── Products ──────────────────────────────────────────────
export const PROPOSAL_PRODUCTS_REQUEST = 'PROPOSAL_PRODUCTS_REQUEST'
export const PROPOSAL_PRODUCTS_SUCCESS = 'PROPOSAL_PRODUCTS_SUCCESS'
export const PROPOSAL_PRODUCTS_FAILURE = 'PROPOSAL_PRODUCTS_FAILURE'

export const PROPOSAL_PRODUCTS_ALL_REQUEST = 'PROPOSAL_PRODUCTS_ALL_REQUEST'
export const PROPOSAL_PRODUCTS_ALL_SUCCESS = 'PROPOSAL_PRODUCTS_ALL_SUCCESS'
export const PROPOSAL_PRODUCTS_ALL_FAILURE = 'PROPOSAL_PRODUCTS_ALL_FAILURE'

export const PROPOSAL_PRODUCT_ADD_REQUEST = 'PROPOSAL_PRODUCT_ADD_REQUEST'
export const PROPOSAL_PRODUCT_ADD_SUCCESS = 'PROPOSAL_PRODUCT_ADD_SUCCESS'
export const PROPOSAL_PRODUCT_ADD_FAILURE = 'PROPOSAL_PRODUCT_ADD_FAILURE'

export const PROPOSAL_PRODUCT_UPDATE_REQUEST = 'PROPOSAL_PRODUCT_UPDATE_REQUEST'
export const PROPOSAL_PRODUCT_UPDATE_SUCCESS = 'PROPOSAL_PRODUCT_UPDATE_SUCCESS'
export const PROPOSAL_PRODUCT_UPDATE_FAILURE = 'PROPOSAL_PRODUCT_UPDATE_FAILURE'

export const PROPOSAL_PRODUCT_DELETE_REQUEST = 'PROPOSAL_PRODUCT_DELETE_REQUEST'
export const PROPOSAL_PRODUCT_DELETE_SUCCESS = 'PROPOSAL_PRODUCT_DELETE_SUCCESS'
export const PROPOSAL_PRODUCT_DELETE_FAILURE = 'PROPOSAL_PRODUCT_DELETE_FAILURE'

// ─── Settings ──────────────────────────────────────────────
export const PROPOSAL_SETTINGS_REQUEST = 'PROPOSAL_SETTINGS_REQUEST'
export const PROPOSAL_SETTINGS_SUCCESS = 'PROPOSAL_SETTINGS_SUCCESS'
export const PROPOSAL_SETTINGS_FAILURE = 'PROPOSAL_SETTINGS_FAILURE'

export const PROPOSAL_SETTINGS_UPDATE_REQUEST = 'PROPOSAL_SETTINGS_UPDATE_REQUEST'
export const PROPOSAL_SETTINGS_UPDATE_SUCCESS = 'PROPOSAL_SETTINGS_UPDATE_SUCCESS'
export const PROPOSAL_SETTINGS_UPDATE_FAILURE = 'PROPOSAL_SETTINGS_UPDATE_FAILURE'

// ─── Seed ──────────────────────────────────────────────────
export const PROPOSAL_SEED_REQUEST = 'PROPOSAL_SEED_REQUEST'
export const PROPOSAL_SEED_SUCCESS = 'PROPOSAL_SEED_SUCCESS'
export const PROPOSAL_SEED_FAILURE = 'PROPOSAL_SEED_FAILURE'

export const PROPOSAL_CATALOG_RESET = 'PROPOSAL_CATALOG_RESET'

// ─── Action Creators ───────────────────────────────────────

export function fetchProposalProducts() {
  return {
    [CALL_API]: {
      method: 'GET',
      endpoint: 'proposalcatalog/products',
      authenticated: true,
      types: [PROPOSAL_PRODUCTS_REQUEST, PROPOSAL_PRODUCTS_SUCCESS, PROPOSAL_PRODUCTS_FAILURE],
    },
  }
}

export function fetchAllProposalProducts() {
  return {
    [CALL_API]: {
      method: 'GET',
      endpoint: 'proposalcatalog/products/all',
      authenticated: true,
      types: [PROPOSAL_PRODUCTS_ALL_REQUEST, PROPOSAL_PRODUCTS_ALL_SUCCESS, PROPOSAL_PRODUCTS_ALL_FAILURE],
    },
  }
}

export function createProposalProduct(data) {
  return {
    [CALL_API]: {
      method: 'POST',
      endpoint: 'proposalcatalog/products',
      body: JSON.stringify(data),
      authenticated: true,
      types: [PROPOSAL_PRODUCT_ADD_REQUEST, PROPOSAL_PRODUCT_ADD_SUCCESS, PROPOSAL_PRODUCT_ADD_FAILURE],
    },
  }
}

export function updateProposalProduct(id, data) {
  return {
    [CALL_API]: {
      method: 'PUT',
      endpoint: `proposalcatalog/products/${id}`,
      body: JSON.stringify(data),
      authenticated: true,
      types: [PROPOSAL_PRODUCT_UPDATE_REQUEST, PROPOSAL_PRODUCT_UPDATE_SUCCESS, PROPOSAL_PRODUCT_UPDATE_FAILURE],
    },
  }
}

export function deleteProposalProduct(id) {
  return {
    [CALL_API]: {
      method: 'DELETE',
      endpoint: `proposalcatalog/products/${id}`,
      authenticated: true,
      types: [PROPOSAL_PRODUCT_DELETE_REQUEST, PROPOSAL_PRODUCT_DELETE_SUCCESS, PROPOSAL_PRODUCT_DELETE_FAILURE],
    },
  }
}

export function fetchProposalSettings() {
  return {
    [CALL_API]: {
      method: 'GET',
      endpoint: 'proposalcatalog/settings',
      authenticated: true,
      types: [PROPOSAL_SETTINGS_REQUEST, PROPOSAL_SETTINGS_SUCCESS, PROPOSAL_SETTINGS_FAILURE],
    },
  }
}

export function updateProposalSettings(data) {
  return {
    [CALL_API]: {
      method: 'PUT',
      endpoint: 'proposalcatalog/settings',
      body: JSON.stringify(data),
      authenticated: true,
      types: [PROPOSAL_SETTINGS_UPDATE_REQUEST, PROPOSAL_SETTINGS_UPDATE_SUCCESS, PROPOSAL_SETTINGS_UPDATE_FAILURE],
    },
  }
}

export function seedProposalCatalog() {
  return {
    [CALL_API]: {
      method: 'POST',
      endpoint: 'proposalcatalog/seed',
      authenticated: true,
      types: [PROPOSAL_SEED_REQUEST, PROPOSAL_SEED_SUCCESS, PROPOSAL_SEED_FAILURE],
    },
  }
}

export function resetProposalCatalog() {
  return { type: PROPOSAL_CATALOG_RESET }
}
